import { Controller } from "@hotwired/stimulus";

// Drives the send-queue batch selection: keeps the "N selected · $total"
// summary live, gates the send button, and syncs the select-all checkbox
// (including its indeterminate state) as individual rows are toggled.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "count", "total", "submit"];
  declare readonly selectAllTarget: HTMLInputElement;
  declare readonly hasSelectAllTarget: boolean;
  declare readonly checkboxTargets: HTMLInputElement[];
  declare readonly countTarget: HTMLElement;
  declare readonly totalTarget: HTMLElement;
  declare readonly submitTarget: HTMLButtonElement;

  private currency = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  connect() {
    this.refresh();
  }

  toggleAll = () => {
    const { checked } = this.selectAllTarget;
    this.checkboxTargets.forEach((box) => (box.checked = checked));
    this.refresh();
  };

  refresh = () => {
    const selected = this.checkboxTargets.filter((box) => box.checked);
    const count = selected.length;
    const total = selected.reduce(
      (sum, box) => sum + Number(box.dataset.amount ?? 0),
      0,
    );

    this.countTarget.textContent =
      count === 1 ? "1 invoice" : `${count} invoices`;
    this.totalTarget.textContent = this.currency.format(total);
    this.submitTarget.disabled = count === 0;
    this.element.classList.toggle("has-selection", count > 0);

    if (this.hasSelectAllTarget) {
      const all = this.checkboxTargets.length;
      this.selectAllTarget.checked = count > 0 && count === all;
      this.selectAllTarget.indeterminate = count > 0 && count < all;
    }
  };
}
